/**
 * 判断当前是否在App的WebView中运行
 * @returns {boolean} 是否在App内
 */
export const isInApp = () => {
  // 检查 Flutter WebView 对象
  if (window.flutterApp) {
    return true;
  }

  // 检查 UserAgent 中是否包含App标识
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('utaxes')) { // App的标识，需要与App端确认具体的标识字符串
    return true;
  }

  // 检查URL参数
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('platform') === 'app') {
    return true;
  }

  return false;
};

/**
 * 获取当前运行环境的详细信息
 * @returns {Object} 环境信息对象
 */
export const getEnvironmentInfo = () => {
  return {
    isInApp: isInApp(),
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    isFlutterWebView: !!window.flutter_inappwebview,
    urlParams: new URLSearchParams(window.location.search).toString()
  };
};

/**
 * 判断是否是开发环境
 * @returns {boolean}
 */
export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development';
};

/**
 * 判断是否是生产环境
 * @returns {boolean}
 */
export const isProduction = () => {
  return process.env.NODE_ENV === 'production';
}; 